import { Button } from "@material-ui/core";
import { makeStyles, Theme } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme: Theme) => ({


    rootSelected: {
        color: 'white',
        width: '100%',
        borderRadius: 0,
        background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat',
    },
    endIcon: {
        //height: 'auto',
        width: 17
    }

}));

type Param = {
    onClick: () => void
}

const BtnNext: React.FC<Param> = ({ onClick }) => {
    const classes = useStyles();
    const text = "WEITER";
    return (
        <Button title={text}
            size='large'
            variant='contained'
            color='secondary'
            onClick={onClick}
            className={classes.rootSelected}
            endIcon={<ArrowForwardIosIcon classes={{ root: classes.endIcon }} />}>
            {text}</Button>
    );
}

export default BtnNext;